module.exports = __webpack_public_path__ + "static/img/S.ba4d586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SuperAce/S.png
// module id = ksAG
// module chunks = 0